module.exports = __webpack_public_path__ + "static/media/rundweg.ea24b236.jpg";